import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Image } from 'components/atoms';
import { SectionHeader } from 'components/molecules';
import { Section } from 'components/organisms';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    position: 'relative',
    background: theme.palette.alternate,
    overflow: 'hidden',
  },
  image: {
    minHeight: 400,
    objectFit: 'cover',
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
      minHeight: 500,
    },
  },
  title: {
    fontWeight: 500,
  },
  textWhite: {
    color: 'white',
  },
  subtitle: {
    fontWeight: 300,
  },
  section: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    paddingTop: 0,
    paddingBottom: 0,
  },
}));

const Hero = props => {
  const { className, ...rest } = props;
  const classes = useStyles();
  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <Image
        src="/images/admissions/topbanner.png"
        srcSet="/images/admissions/topbanner.png"
        alt="About"
        className={classes.image}
        lazyProps={{
          width: '100%',
          height: '100%',
        }}
      />
      <Section className={classes.section}>
        <Grid item xs={12} md={9} data-aos={'fade-up'}>
          <SectionHeader
            title="Admissions Process"
            subtitle={
              <span>
                We accept applications on a rolling basis, so students can start their courses whenever it is most convenient. 
                We also encourage prospective students and parents to get in touch with a member of our admissions team. 
                To set up a consultation or a class demo, please call us at <span style={{ color: "#F9B934" }}>201-408-2236</span>, or 
                set up an appointment with an admissions specialist by emailing 
                {' '}<span style={{ color: "#F9B934" }}>admissions@englewoodohs.org</span>
              </span>
            }
            align="left"
            data-aos="fade-up"
            disableGutter
            titleProps={{
              className: clsx(classes.title, classes.textWhite),
              variant: 'h2',
            }}
            subtitleProps={{
              className: clsx(classes.subtitle, classes.textWhite),
              variant: 'h5',
            }}
          />
        </Grid>
      </Section>
    </div>
  );
};

Hero.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Hero;
